import { useState } from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const RecipeIngredients = ({
  localRecipe,
  handleLocalIngredientChange,
  onAddIngredient,
  onRemoveIngredient,
  onSelectSuggestion,
  ingredientSuggestions,
  showSuggestions,
  activeIngredientIndex,
  setShowSuggestions,
  setActiveIngredientIndex,
  setIngredientSuggestions,
  isSubmitting
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        <label className="block text-sm font-medium text-gray-700">Ingredients*</label>
        <button
          type="button"
          onClick={onAddIngredient}
          className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 transition-colors"
          disabled={isSubmitting}
        >
          <FiPlus size={14} /> Add Ingredient
        </button>
      </div>
      
      <div className="space-y-3">
        {localRecipe.ingredients.map((ingredient, index) => (
          <div 
            key={index} 
            id={`ingredient-${index}`}
            className="grid grid-cols-12 gap-2 items-end bg-gray-50 p-3 rounded-lg border border-gray-200"
          >
            <div className="col-span-5 relative">
              <label className="block text-xs text-gray-500 mb-1">Name*</label>
              <input
                type="text"
                value={ingredient.name}
                onChange={(e) => handleLocalIngredientChange(index, 'name', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                required
                placeholder="e.g. Chicken"
                disabled={isSubmitting}
              />
              {showSuggestions && activeIngredientIndex === index && ingredientSuggestions.length > 0 && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                  {ingredientSuggestions.map((suggestion, i) => (
                    <div
                      key={i}
                      className="px-3 py-2 hover:bg-gray-100 cursor-pointer transition-colors"
                      onClick={() => {
                        onSelectSuggestion(suggestion);
                        setShowSuggestions(false);
                      }}
                    >
                      {suggestion}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="col-span-3">
              <label className="block text-xs text-gray-500 mb-1">Quantity*</label>
              <input
                type="number"
                value={ingredient.quantity}
                onChange={(e) => handleLocalIngredientChange(index, 'quantity', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                required
                min="0"
                step="any"
                placeholder="0"
                disabled={isSubmitting}
              />
            </div>
            <div className="col-span-3">
              <label className="block text-xs text-gray-500 mb-1">Unit*</label>
              <select
                value={ingredient.unit}
                onChange={(e) => handleLocalIngredientChange(index, 'unit', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                required
                disabled={isSubmitting}
              >
                <option value="kg">kg</option>
                <option value="g">g</option>
                <option value="lb">lb</option>
                <option value="oz">oz</option>
                <option value="pcs">pcs</option>
                <option value="ml">ml</option>
                <option value="l">l</option>
                <option value="cup">cup</option>
                <option value="tbsp">tbsp</option>
                <option value="tsp">tsp</option>
              </select>
            </div>
            <div className="col-span-1 flex justify-end">
              <button
                type="button"
                onClick={() => onRemoveIngredient(index)}
                className="p-2 text-gray-500 hover:text-red-600 rounded-md hover:bg-gray-100 transition-colors"
                disabled={localRecipe.ingredients.length <= 1 || isSubmitting}
                title="Remove ingredient"
              >
                <FiTrash2 />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecipeIngredients;